<template>
  <div>
    
  </div>
</template>



<script>
// Ajax通信ライブラリ
import axios from "axios";


export default {
  name: "LIST",
  components: {
    // draggable
  },
  data() {
    return {
      height: 0,
      dialog: false,

      list: [],
      editedIndex: -1,
      editedItem: {
        id: "", //リンク
        name: "",
        pv: ""
      },

      // 入力規則
      required: value => !!value || "必ず入力してください" // 入力必須の制約
    };
  },

  computed: {},

  methods: {
  },

  created: function() {

      axios
        .get(process.env.VUE_APP_SEEDAPP_LIST, {
          params: {},
        })
        .then((response) => {
          console.log(response);
          // console.log(this.list);
        });
  }
};
</script>

<style scoped>
.article_list {
  overflow-y: scroll;
}

.article_list .v-card {
  counter-increment: count;
}
.article_list .v-card .article_url::before {
  content: counter(count) "位";
  margin: 2px 14px 2px 15px;
  padding: 2px 4px;
  border: 1px solid #aaa;
  border-radius: 4px;
  min-width: 40px;
  text-align: center;
  display: inline-block;
  font-size: 13px;
}

.label {
  margin-right: 6px;
  border-right: 1px solid #ddd;
}

.article_url {
  padding-right: 8px;
}

.article_item {
  max-width: 1200px;
}

.pv {
  display: inline-block;
  min-width: 40px;
  background: #eee;
  text-align: center;
  font-size: 12px;
}

.drag {
  display: block;
  text-align: center;
  padding: 2px;
}
</style>